Vue.component('toggle-manager', {
    props: {
        param: { type: String, default: 'fullName' },
        property: { type: String, default: 'selected' },
        text: {
            type: Object,
            default: function () {
                return {
                    filter: {
                        selected: 'Show selected only',
                        all: 'Show all'
                    },
                    recap: '<span>Selected </span><strong>%s</strong><span> of </span><strong>%a</strong>',
                    error: 'An error occurred'
                }
            }
        },
        search: Object,
        prefilter: Boolean,
        source: undefined,
        toggleon: undefined,
        toggleoff: undefined,
        readonly: Boolean
    },
    beforeMount: function () {
        if (!this.source) return this.onerror(new TypeError('Invalid source passed to Toggle Manager'));

        try {
            if (Promise.prototype.isPrototypeOf(this.source)) {
                this.source.then(this.onload).catch(this.onerror);
            } else {
                if (Array.isArray(this.source)) {
                    this.onload(this.source);
                } else {
                    this.load(this.source).then(this.onload).catch(this.onerror);
                }
            }
        } catch (error) {
            this.onerror(error);
        }

        this.onlyselected = this.prefilter;
    },
    watch: {
        error: function (value) {
            var isError = value === true || Error.prototype.isPrototypeOf(value);
            this.className['-error'] = isError;
            this.message = isError
                ? Vue.config.devtools
                    ? value.message
                    : this.text.error
                : null;
        },
        loading: function (value) {
            this.className['-loading'] = value;
        }
    },
    computed: {
        selected: function () {
            return this.items.filter(function (el) { return el[this.property] == true }, this);
        },
        recap: function () {
            return this.text.recap.replace('%s', this.selected.length).replace('%a', this.items.length);
        }
    },
    methods: {
        load: function (url) {
            if (typeof (url) !== 'string') return Promise.reject(new ReferenceError('No url to fetch'));
            return fetch(url)
                .then(function (response) { return (response.ok) ? response.json() : Promise.reject(response); })
                .catch(function (error) { return Promise.reject(error) });
        },
        onload: function (data) {
            this.loading = false;
            this.error = false;
            data.forEach(function (el) { el.locked = false; });
            this.items = data;
            this.filter();
        },
        toggle: function (id) {
            if (this.readonly)
                return;

            var dotoggle = function (item, property, handler) {
                if (typeof (handler) === 'function') {
                    var result = handler(item);
                    if (Promise.prototype.isPrototypeOf(result)) {
                        return result;
                    } else {
                        return Promise.resolve(result);
                    }
                } else {
                    item[property] = true;
                    return Promise.resolve(item)
                }
            }

            var el = this.items.find(function (el) { return el.id === id; });
            this.setvalue(el, 'locked', true);
            var handler = el[this.property] ? this.toggleoff : this.toggleon;
            try {
                dotoggle(el, this.property, handler).then(this.ontoggle).catch(this.onerror);
            } catch (error) {
                this.onerror(error);
            }
        },
        ontoggle: function (item) {
            this.setvalue(item, this.property, item[this.property]);
            this.setvalue(item, 'locked', false);
            this.filter();
        },
        setvalue: function (el, prop, value) {
            var index = this.items.indexOf(el);
            el[prop] = value;
            this.$set(this.items, index, el);
        },
        onSearchFocus: function (event) {
            this.onlyselected = false;
            this.filter();
        },
        onSearchBlur: function (event) {
            this.filter();
        },
        togglefilter: function (event) {
            event.preventDefault();
            this.onlyselected = !this.onlyselected;
            this.filter();
        },
        filter: function () {
            if (this.onlyselected) {
                this.searchvalue = '';
                this.$set(this.search, 'value', this.searchvalue);
                this.$set(this.search, 'items', this.selected);
            } else {
                this.$set(this.search, 'items', this.items);
            }
        },
        onerror: function (error) {
            console.warn(error);
            this.error = error;
            this.loading = false;
        }
    },
    data: function () {
        return {
            error: false,
            loading: true,
            onlyselected: false,
            message: null,
            searchvalue: '',
            className: {
                'toggle-manager': true,
                '-error': false,
                '-loading': true
            },
            items: []
        }
    },
    template: '<div :class="className">'
        + '<div class="filter">'
        + '<span class="recap" v-html="recap"></span>'
        + '<a v-if="!onlyselected" class="filterbutton arsv-action-button -use" @click="togglefilter">{{text.filter.selected}}</a>'
        + '<a v-if="onlyselected" class="filterbutton arsv-action-button -use" @click="togglefilter">{{text.filter.all}}</a>'
        + '</div>'
        + '<search-box v-if="!error" v-bind="search" v-model="searchvalue" @focus="onSearchFocus" @blur="onSearchBlur" :readonly="readonly">'
        + '<template slot="item" slot-scope="category">'
        + '<category-item v-bind="category" @click="toggle" :readonly="readonly"></category-item>'
        + '</template>'
        + '</search-box>'
        + '<div class="message" v-if="error">{{message}}</div>'
        + '<div class="loader arsv-load-spinner"></div>'
        + '</div>'
});
